import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import FormikControl from 'components/wrapperComponents/FormikControl';
import { msgTypes } from 'constants/msgTypes';
import { Form, Formik } from 'formik';
import { MembershipModel } from 'model/screensModels/membership/MembershipModel';
import { ResetPasswordModel } from 'model/screensModels/membership/ResetPasswordModel';
import React, { useEffect, useState } from 'react'
import { ResetPasswordSchema } from 'schemas/menu/auth/ResetPasswordSchema';
import { MembershipService } from 'services/menu/membership/MembershipService';

const ResetPasswordDialogBox = ({ open, setOpen, rowData }) => {
    const [initialValue, setInitialValue] = useState(new ResetPasswordModel());

    const handleClose = () => {
        setOpen(false);
    };

    const onSubmit = async (values: ResetPasswordModel) => {
        resetPassword(values)
    }


    const resetPassword = async (values: ResetPasswordModel) => {
        const requestData: MembershipModel = new MembershipModel();
        requestData.companyId = rowData.companyId;
        requestData.userName = values.userName;
        requestData.password = values.password;
        const res = await MembershipService.updateUserIdAndPassword(requestData);
    }

return (
    <>
        <Formik
            enableReinitialize={true}
            initialValues={initialValue}
            validationSchema={ResetPasswordSchema}
            onSubmit={onSubmit}
        >
            {
                ({ isValid, dirty, isSubmitting, values }) => (
                    <Form>
     
                            <Dialog
    open={open}
    onClose={(event, reason) => {
        if (reason !== "backdropClick") {
            handleClose();
        }
    }}
    className="forget-password-section"
    PaperProps={{
        component: "form",
        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            handleClose();
        },
    }}
>
                            <DialogTitle><h6>Reset User Id and Password</h6>
                            <strong><h5>{rowData.companyName}</h5></strong>
                            </DialogTitle>
                            <DialogContent>
                            <div className="row">
                            <div className='col-lg-12 position-relative'>
                                      <FormikControl
                                        control="textfield"
                                        name="userName"
                                        label="User Name"
                                        placeholder="Enter User Name"
                                        requiredField
                                      />
                                    </div>
                                    <div className='col-lg-12 password-feild position-relative'>
                                      <FormikControl
                                        control="passwordfield"
                                        name="password"
                                        label="Password"
                                        placeholder="Enter Password"
                                        requiredField
                                      />
                                    </div>
                                    </div>
                            </DialogContent>
                            <DialogActions className='mt-2'>
                                <FormikControl control='button' className="btn btn-submit" color="primary" label="Reset Password" type="submit" disabled={!dirty || !isValid} />
                                <FormikControl control='button' className="btn btn-cancel"  onClick={handleClose} label="Cancel" />
                                {/* <Button type="submit"></Button> */}
                            </DialogActions>
                        </Dialog>
                    </Form>
                )
            }
        </Formik>
    </>
)
}

export default ResetPasswordDialogBox